<template>
  <section class="status">
    <div class="status__header">
      <h2 class="wd-title">Tu estatus <br class="br-m" /><span class="hl">dentro del sistema</span></h2>
      <p class="wd-body">
        Cada estatus representa una etapa de tu proceso. Consulta tu situación actual en Mi financiamiento.
      </p>
    </div>

    <ol class="status__steps">
      <li
        v-for="step in steps"
        :key="step.number"
        class="status__step"
        :class="{ 'status__step--active': step.number === activeStep }"
      >
        <span class="status__dot" aria-hidden="true" />
        <article class="wd-card status__card">
          <span v-if="step.number === activeStep" class="wd-tag-success">Estas aquí</span>
          <p class="status__title">{{ step.number }} {{ step.title }}</p>
          <p class="wd-body" v-html="step.description" />
        </article>
      </li>
    </ol>
  </section>
</template>

<script setup lang="ts">
defineProps<{ activeStep?: '01' | '02' | '03' | '04' }>()
const steps = [
  { number: '01', title: 'Solicitante', description: 'Ya realizaste <br class="br-tm">tu contratación' },
  { number: '02', title: 'Integrante', description: 'Formas parte <br class="br-tm">activa del grupo' },
  {
    number: '03',
    title: 'Adjudicatario',
    description: 'Estás en posibilidad <br class="br-tm">de obtener <br class="br-tm">tu financiamiento'
  },
  { number: '04', title: 'Adjudicado', description: 'Ya obtuviste <br class="br-tm">tu financiamiento' }
]
</script>

<style scoped>
.status {
  /* Riel del timeline: ancho de la columna y separación con las cards */
  --rail: 74px;
  --rail-gap: 24px;
  --step-gap: 32px;
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-7);
}
.status__header {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-4);
}

.status__steps {
  display: flex;
  flex-direction: column;
  gap: var(--step-gap);
  margin: 0;
  padding: 0;
  list-style: none;
}

/* Cada paso dibuja su punto y los tramos de línea hacia el paso anterior y el siguiente */
.status__step {
  position: relative;
  padding-left: calc(var(--rail) + var(--rail-gap));
}
.status__step::before,
.status__step::after {
  content: '';
  position: absolute;
  left: calc(var(--rail) / 2 - 1px);
  width: 2px;
  background: var(--ds-border-card);
}
.status__step::before {
  top: 0;
  height: 50%;
}
.status__step::after {
  top: 50%;
  height: calc(50% + var(--step-gap));
}
.status__step:first-child::before,
.status__step:last-child::after {
  display: none;
}

.status__dot {
  position: absolute;
  top: 50%;
  left: calc(var(--rail) / 2 - 8px);
  z-index: 1;
  width: 16px;
  height: 16px;
  transform: translateY(-50%);
  border-radius: 50%;
  background: var(--ds-border-card);
}
.status__step--active .status__dot {
  background: #ff8f1c;
}

.status__card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--ds-space-4);
}
.status__title {
  margin: 0;
  color: var(--ds-secondary-main);
  font-family: var(--ds-font-family-bebas);
  font-size: 32px;
  font-weight: 700;
  line-height: normal;
}

@media (min-width: 600px) and (max-width: 1024px) {
  .status {
    --rail: 70px;
    --rail-gap: 0px;
  }
}

@media (max-width: 599px) {
  .status {
    --rail: 70px;
    --rail-gap: 16px;
    gap: var(--ds-space-6);
  }
}
</style>
